class CookieHelper {
    /**
     * retrieves value stored in specific cookie as a string
     * @param name
     * @returns {string|null}
     */
    static getCookieValue(name) {
        const regex = new RegExp(`${name}=([^;]+)`);
        const value = regex.exec(document.cookie);

        return (value != null) ? value[1] : null;
    }

    /** get cookie by name
     * @param name
     * @returns {boolean}
     */
    static getCookie(name) {
        return document.cookie.split(';').some((c) => {
            return c.trim().startsWith(`${name}=`);
        });
    }

    /**
     * remove cookie
     * @param name
     */
    static clearCookie(name) {
        if (CookieHelper.getCookie(name)) {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
        }
    }

    /**
     * set cookie
     * @param name
     * @param value
     * @param expirationDays
     */
    static setCookie(name, value, expirationDays = 31) {
        const date = new Date();
        date.setTime(date.getTime() + (expirationDays * 24 * 60 * 60 * 1000));

        document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    }

    /**
     * listen for change in cookieconsent and trigger
     * custom event if marketing cookies have been accepted
     */
    static addMarketingCookieListener(customEvents = []) {
        CookieHelper.consentInitialized = false;
        window.addEventListener('UC_CONSENT', (e) => {
            if (CookieHelper.consentInitialized === false) {
                CookieHelper.consentInitialized = true;
                return;
            }
            if (e.detail) {
                for (const event of customEvents) {
                    if (event === 'consent-type-youtube') {
                        const services = e.detail?.services || {};

                        const youtubeConsentGiven = Object.values(services).some(
                            (service) => service.name === 'YouTube Video' && service.consent?.given === true,
                        );

                        window.youtubeConsentGiven = youtubeConsentGiven;

                        let customEvent = new CustomEvent('consent-withdraw-youtube');
                        if (youtubeConsentGiven) {
                            customEvent = new CustomEvent('consent-type-youtube');
                        }
                        window.dispatchEvent(customEvent);
                    }
                    if (event === 'consent-type-google-maps') {
                        const services = e.detail?.services || {};

                        const mapsConsentGiven = Object.values(services).some(
                            (service) => service.name === 'Google Maps' && service.consent?.given === true,
                        );

                        window.mapsConsentGiven = mapsConsentGiven;

                        let customEvent = new CustomEvent('consent-withdraw-maps');
                        if (mapsConsentGiven) {
                            customEvent = new CustomEvent('consent-type-google-maps');
                        }
                        window.dispatchEvent(customEvent);
                    }
                }
            }
        }, false);
    }
}

export default CookieHelper;
